import { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';
import Icon, { IconColor, IconScale, IconShape, IconView } from 'bloko/blocks/icon';

import useTrls from 'hooks/translation/useTrls';

import LabelSort from 'components/Admin/Reports/ActsReport/ActsTable/Header/LabelSort';
import { sortActs } from 'components/Admin/Reports/ActsReport/ActsTable/Header/sortActs';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { ActStatus } from 'store/models/acts';
import { useDispatch } from 'store/utils';

const COLUMN_STATUS = 'status';
const COLUMN_TYPE = 'type';
const COLUMN_EMPLOYER = 'employerId';

const Header = ({ acts, disableSorts, showDate = false }) => {
    const dispatch = useDispatch();

    const trl = useTrls();

    const onClick = useCallback(
        (sortType) => {
            if (!disableSorts) {
                dispatch(sortActs(sortType));
            }
        },
        [disableSorts, dispatch]
    );
    const haveWaiting1cStatus = useMemo(
        () => acts?.filter((act) => act.status === ActStatus.Waiting1C)?.length > 0,
        [acts]
    );
    return (
        <TableRow>
            {showDate && <TableHeadCell>{trl('admin.actsReport.actsTable.header.date')}</TableHeadCell>}
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.actName')}</TableHeadCell>
            <TableHeadCell onClick={() => onClick(COLUMN_EMPLOYER)}>
                <LabelSort column={COLUMN_EMPLOYER} disableSorts={disableSorts} />
            </TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.account')}</TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.amount')}</TableHeadCell>
            <TableHeadCell onClick={() => onClick(COLUMN_TYPE)}>
                <LabelSort column={COLUMN_TYPE} disableSorts={disableSorts} />
            </TableHeadCell>
            <TableHeadCell onClick={() => onClick(COLUMN_STATUS)} colSpan={2}>
                <LabelSort
                    column={COLUMN_STATUS}
                    disableSorts={disableSorts}
                    tip={
                        haveWaiting1cStatus ? (
                            <HoverTip
                                placement={TipPlacement.Top}
                                render={() => trl('admin.actsReport.actsTable.header.warring')}
                                host={document.body}
                                DropElement={Tip}
                            >
                                <Icon
                                    view={IconView.Exclamation}
                                    initial={IconColor.SpecialRedBranded}
                                    shape={IconShape.Triangle}
                                    scale={IconScale.Small}
                                />
                            </HoverTip>
                        ) : null
                    }
                />
            </TableHeadCell>
        </TableRow>
    );
};

Header.propTypes = {
    dispatch: PropTypes.func,
    acts: PropTypes.arrayOf(
        PropTypes.shape({
            status: PropTypes.string,
        })
    ),
    disableSorts: PropTypes.bool,
    showDate: PropTypes.bool,
    isEditing: PropTypes.bool,
};

Header.defaultProps = {
    disableSorts: false,
};

export default Header;
